import { useEffect, useState } from 'react';

let cachedPromise = null;

function loadAddresses() {
  if (!cachedPromise) {
    cachedPromise = fetch('/addresses/ph_addresses.json').then((res) => res.json());
  }
  return cachedPromise;
}

export function usePhAddresses() {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    loadAddresses()
      .then((data) => {
        if (mounted) setAddresses(data);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  return { addresses, loading };
}
